export const IMAGE_MIME_TYPE = new Map([
    ['.jpg', 'image/jpeg'],
    ['.jpeg', 'image/jpeg'],
    ['.png', 'image/png'],
    ['.gif', 'image/gif'],
    ['.bmp', 'image/bmp'],
    ['.tif', 'image/tiff'],
    ['.tiff', 'image/tiff'],
    ['.ico', 'image/x-icon'],
    ['.emf', 'image/emf'],
    ['.wmf', 'image/wmf'],
    ['.svg', 'image/svg+xml'],
    ['.webp', 'image/webp'],
    ['.wdp', 'image/vnd.ms-photo'],
]);

export const AUDIO_MIME_TYPE = new Map([
    ['.mp3', 'audio/mpeg'],
    ['.wav', 'audio/wav'],
    ['.wma', 'audio/x-ms-wma'],
]);

export const VIDEO_MIME_TYPE = new Map([
    ['.mp4', 'video/mp4'],
    ['.mov', 'video/quicktime'],
    ['.avi', 'video/x-msvideo'],
    ['.wmv', 'video/x-ms-wmv'],
    ['.mkv', 'video/x-matroska'],
    ['.flv', 'video/x-flv'],
    ['.mpeg', 'video/mpeg'],
    ['.mpg', 'video/mpeg'],
    ['.3gp', 'video/3gpp'],
]);
